import React, { useState } from 'react';
import { MdOutlineDelete } from 'react-icons/md';
import { RiEditLine } from 'react-icons/ri';
import { VscSymbolField } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import CreateLectureModal from './CreateLectureModal';
import { deleteSubSection } from '../../../../../../redux/slices/courseSlice';

const SubSection = ({
    subSection,
    setValue,
    register,
    getValues,
    reset,
    errors,
    sectionIndex,
    sectionName,
    subSectionIndex
}) => {
    const [isEdit, setEdit] = useState(false);
    const dispatch = useDispatch();

    const subSectionData = {
        title: subSection.title,
        description: subSection.description,
        fileType: subSection.fileType,
        file: subSection.file,
        duration: subSection.duration,
    }
    const deleteSubSectionHandler = (subSectionIndex) => {
        dispatch(deleteSubSection({ subSectionIndex, sectionName, sectionIndex }));
    }

    return (
        <div>
            <div className='flex justify-between items-center text-lg px-3 my-1 border-b border-richblack-700 py-2'>
                <div className='flex items-center justify-between w-full'>
                    <div className='flex items-center gap-x-5 w-full'>
                        <div className='text-xl'>
                            <VscSymbolField />
                        </div>
                        <div
                            className='w-full bg-richblack-800 rounded-[0.5rem] text-richblack-5 cursor-default'
                        >
                            {subSection.title}
                        </div>
                    </div>
                    <div className='flex items-center gap-x-6 text-xl mx-2'>
                        <button
                            onClick={() => {
                                setEdit(true);
                            }}
                            type='button'
                        >
                            <RiEditLine />
                        </button>
                        <button
                            type='button'
                        >
                            <MdOutlineDelete
                                onClick={() => deleteSubSectionHandler(subSectionIndex)}
                            />
                        </button>
                    </div>
                </div>
            </div>
            <div>
                {isEdit &&
                    <CreateLectureModal
                        subSectionData={subSectionData}
                        register={register}
                        setValue={setValue}
                        getValues={getValues}
                        setShowModal={setEdit}
                        errors={errors}
                        sectionIndex={sectionIndex}
                        subSectionIndex={subSectionIndex}
                        reset={reset}
                        sectionName={sectionName}
                    />
                }
            </div>
        </div>
    );
};

export default SubSection;